import { cacheDom } from '../utils/QuerySelectors.js'
import { makeLineItem, addLineItems } from '../utils/Cart.js'
import { money } from '../utils/helpers'

const state = {
  json: null,
  initialX: null,
  initialY: null,
}
const dom = {}
const qs = {
  section: 'data-section-type="main-product"',
  swiper: 'data-gallery-swiper',
  thumbs: 'data-gallery-thumb-swiper',
  json: 'data-products-json',
  productJson: 'data-main-json',
  oosBtn: 'data-oos',
  price: 'data-pdp-price',
  optionValue: 'data-option-value',
  showAll: 'data-show-all',
  colorModal: 'data-pdp-colors',
  colorModalMain: 'data-pdp-colors-inner',
  // description: 'data-description',
  // accordionFeature: 'data-accordion-features',
  // accordionMaterial: 'data-accordion-materials',
  // accordionShipping: 'data-accordion-shipping',
  // accordionFeatureDetail: 'data-pdp-acc-features',
  // accordionMaterialDetail: 'data-pdp-acc-materials',
  // accordionShippingDetail: 'data-pdp-acc-shipping-returns',
  colorPanelClose: 'data-pdp-colors-close',
  variantSelect: 'data-variant-selector',
  sku: 'data-sku',
  priceWrapper: 'data-pdp-price',
  zoomModal: 'data-media-zoom',
}
const qsAll = {
  slideImages: 'data-slide-image',
  // swatches: 'data-pdp-swatch',
  formBtns: 'data-form-btn',
  colorStyles: 'data-color-style',
  colorPanels: 'data-color-panel',
  paymentForms: 'data-additional-payment',
  tabButtons: 'data-pdp-tab-btn',
}

const toggleColorModal = (toggle = true) => {
  dom.colorModal.classList.toggle('z-[-1]', !toggle)
  dom.colorModal.classList.toggle('opacity-0', !toggle)
  dom.colorModal.classList.toggle('z-50', toggle)
  dom.colorModal.classList.toggle('opacity-100', toggle)

  dom.colorModalMain.classList.toggle('right-[-31rem]', !toggle)
  dom.colorModalMain.classList.toggle('right-0', toggle)
  if (toggle) dom.colorPanelClose.focus()

  document.body.classList.toggle('overflow-hidden', toggle)
  if (!toggle) dom.showAll.focus()
}

const startTouch = (e) => {
  state.initialX = e.touches[0].clientX
  state.initialY = e.touches[0].clientY
}
const moveTouch = (e) => {
  if (state.initialX === null) {
    return
  }

  if (state.initialY === null) {
    return
  }

  var currentX = e.touches[0].clientX
  var currentY = e.touches[0].clientY

  var diffX = state.initialX - currentX
  var diffY = state.initialY - currentY

  if (Math.abs(diffX) > Math.abs(diffY)) {
    // sliding horizontally
    if (diffX > 0) {
      // swiped left
      console.log('swiped left')
    } else {
      // swiped right
      console.log('swiped right')
    }
  } else {
    // sliding vertically
    if (diffY > 0) {
      // swiped up
      console.log('swiped up')
    } else {
      // swiped down
      console.log('swiped down')
    }
    if (!dom.zoomModal.querySelector('.swiper-slide-zoomed')) {
      window.closeZoomModal()
      state.initialX = null
      state.initialY = null
    }
  }

  state.initialX = null
  state.initialY = null

  e.preventDefault()
}

export const setupProduct = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    const productData = JSON.parse(dom.productJson.innerHTML)
    if (dom.showAll) {
      dom.showAll.addEventListener('click', () => {
        toggleColorModal()
      })
      dom.colorModal.addEventListener('click', () => {
        toggleColorModal(false)
      })
      dom.colorModal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') toggleColorModal(false)
      })
      dom.colorModalMain.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    }
    if (dom.colorPanelClose) {
      dom.colorPanelClose.addEventListener('click', () => {
        toggleColorModal(false)
      })
    }
    dom.colorStyles.forEach((colorStyle) => {
      colorStyle.addEventListener('click', (e) => {
        const colorStyle = e.target.dataset.colorStyle
        dom.colorStyles.forEach((tempStyle) => {
          tempStyle.classList.toggle('opacity-50', tempStyle != e.target)
          tempStyle.setAttribute('aria-selected', tempStyle == e.target ? 'true' : 'false')
        })
        dom.colorPanels.forEach((panel) => {
          panel.classList.toggle('grid', colorStyle == panel.dataset.colorPanel)
          panel.classList.toggle('hidden', colorStyle != panel.dataset.colorPanel)
        })
      })
    })
    if (dom.variantSelect) {
      dom.variantSelect.addEventListener('change', (e) => {
        const selectedOption = e.target.querySelector('option:checked')
        const sku = selectedOption ? selectedOption.dataset.variantSku : null
        const price = selectedOption ? selectedOption.dataset.variantPrice : null
        const comparePrice = selectedOption ? selectedOption.dataset.variantComparePrice : null
        dom.sku.innerHTML = `#${sku}`
        dom.priceWrapper.innerHTML = `${money(price)}${comparePrice && parseFloat(comparePrice) > parseFloat(price) ? '<span class="price-compare">' + money(comparePrice) + '</span>' : ''}`
      })
    }

    dom.formBtns.forEach((formBtn) => {
      formBtn.addEventListener('click', (e) => {
        const items = [
          makeLineItem(document.querySelector('[data-variant-selector] option:checked').value, 1, productData.tags),
        ]
        addLineItems(null, items, true, e.target)
        e.target.disabled = true
      })
    })
    dom.zoomModal.addEventListener('touchstart', startTouch, false)
    dom.zoomModal.addEventListener('touchmove', moveTouch, false)

    const activateTab = (tabButton, setFocus = true) => {
      const id = tabButton.getAttribute(qsAll.tabButtons)
      const content = document.getElementById(id)
      dom.tabButtons.forEach((btn) => {
        const btnId = btn.getAttribute(qsAll.tabButtons)
        const btnContent = document.getElementById(btnId)
        btn.classList.remove('underline')
        btn.setAttribute('aria-selected', 'false')
        // Intentionally NOT roving tabindex: keep all tabs at 0 so Tab reaches each heading.
        btn.setAttribute('tabindex', '0')
        if (btnContent) btnContent.classList.add('hidden')
      })
      tabButton.classList.add('underline')
      tabButton.setAttribute('aria-selected', 'true')
      tabButton.setAttribute('tabindex', '0')
      if (content) content.classList.remove('hidden')
      if (setFocus) tabButton.focus()
    }

    dom.tabButtons.forEach((tabButton, index) => {
      tabButton.addEventListener('click', () => activateTab(tabButton, false))
      // Focusing a heading (via Tab) reveals its panel.
      tabButton.addEventListener('focus', () => activateTab(tabButton, false))
      tabButton.addEventListener('keydown', (e) => {
        const count = dom.tabButtons.length
        let nextIndex = null
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          nextIndex = (index + 1) % count
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          nextIndex = (index - 1 + count) % count
        } else if (e.key === 'Home') {
          nextIndex = 0
        } else if (e.key === 'End') {
          nextIndex = count - 1
        }
        if (nextIndex !== null) {
          e.preventDefault()
          activateTab(dom.tabButtons[nextIndex])
        }
      })
    })
  }
}
